/**
 * screens/AssignmentRegister/emptyState.ts
 * Copy for the register's educational panel. Its flow strip highlights
 * "Assign", because the register IS the record of assignment.
 */
import type { FlowNode, Step } from '../../components/EmptyState';

export const REGISTER_FLOW: readonly FlowNode[] = [
  { key: 'assign', label: 'Assign', sub: 'cash into custody', here: true },
  { key: 'record', label: 'Record', sub: 'spends and collections' },
  { key: 'count', label: 'Count', sub: 'prove the balance' },
  { key: 'route', label: 'Route', sub: 'to Payroll or Billing' },
];

export const REGISTER_STEPS: readonly Step[] = [
  {
    n: '1',
    label: 'Choose who holds it',
    hint: 'An employee, a contractor, a vehicle, a shift, a store or an agent.',
  },
  {
    n: '2',
    label: 'Choose the scope',
    hint: 'Open cash, a purpose wallet with an end rule, or a collection bag.',
  },
  {
    n: '3',
    label: 'Open the row for its ledger',
    hint: 'Every movement, its evidence, and where each consequence went.',
  },
];

export const REGISTER_COPY = {
  eyebrow: 'Assignment register',
  title: 'No cash has been assigned yet',
  blurb:
    'One row per custodian. Each row carries a balance, the date it was last counted, and its full ledger.',
  flowNote:
    'Scope is fixed at three values because each one behaves differently: a purpose wallet expires, and a collection bag reconciles against what Billing says is owed.',
  footNote: 'Assign cash to your first holder to begin.',
} as const;
